import {format, parseISO} from "date-fns";
import React, {useEffect, useState} from "react";
import _ from "lodash/fp";
import {Tooltip, Typography, withStyles} from '@material-ui/core';
import {getStorageValue} from "../utils/localStorageUtils";

export const getHoursDifference = () => {
  const localTime = new Date()
  //time zone value for Hong Kong
  const timeZoneFromDB = +8.0
  //get the timezone offset from local time in minutes
  const tzDifference = timeZoneFromDB * 60 + localTime.getTimezoneOffset()
  //convert the offset to milliseconds, add to localTime, and make a new Date
  const hongKongTime = new Date(localTime.getTime() + tzDifference * 60 * 1000)

  const hoursDifferenceBetweenHk = Math.abs(hongKongTime - localTime) / 36e5
  return hoursDifferenceBetweenHk
}

export const getFormattedTimeDifference = (hours, thirty) => {
  const hoursDifference = getHoursDifference()
  const date = new Date()
  date.setHours(hours - hoursDifference)
  const finalHours = date.getHours()
  if (finalHours === 0) return '12:00 AM'
  if (finalHours > 12) return finalHours - 12 + (thirty ? ':30 PM' : ':00 PM')
  return finalHours + (thirty ? ':30 AM' : ':00 AM')
}


export const clarificationGridColumnDefinition = (addTeam = false) => {

 let columnDef = [
  {
    field: 'category',
    headerName: 'Category',
    minWidth: 280,
    flex: 1
  },
  {
    field: 'clarificationSought',
    headerName: 'Clarification Sought',
    minWidth: 280,
    flex: 1
  },
  {
    field: 'rationale',
    headerName: 'Rationale',
    minWidth: 280,
    flex: 1
  },
  {
    field: 'createdAt',
    headerName: 'Date Submitted',
    width: 120,
    renderCell: params => format(parseISO(params.row.createdAt),'yyyy-MM-dd'),
    valueGetter: params => format(parseISO(params.row.createdAt),'yyyy-MM-dd HH:mm O')
  }
  ]

  if (addTeam){

    columnDef = [ {
      field: "",
      headerName: "School",
      flex : 1,
      valueGetter: params => params.row.team.school
    },...columnDef]
  }
  return columnDef
}


export const friendlyRoundName = roundType =>{
    switch (roundType){
        case 'General Rounds':
            return 'General Round'
        case 'Elimination Rounds: Round of 32':
            return 'Round of 32'
        case 'Elimination Rounds: Round of 16':
            return 'Round of 16'
        case 'Elimination Rounds: Quarter-Finals':
            return 'Quarterfinal'
        case 'Elimination Rounds: Semi-Finals':
            return 'Semifinal'
        case 'Elimination Rounds: Finals':
            return 'final'
        default:
            return roundType
    }
}

export const asHKCurrency = (value, fractionDigits = 2) =>{
    const valueLocaleString = value.toLocaleString('zh-HK',{style: 'currency', currency: 'HKD',minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits})
    const currencyWithSpace = valueLocaleString.split("$").join("$ ");
    return currencyWithSpace
}

export const formatCurrency = (value, prependText) => {
    const formattedValue = asHKCurrency(Math.abs(value))
    return <><span>{prependText} </span><span className={value < 0 ? 'negative-value' : 'positive-value'}>{value < 0 ? `(${formattedValue})` : `${formattedValue}`}</span></>

}


const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    maxWidth: 180,
    userSelect: 'text',
  },
}))(Tooltip);

export const CustomTooltip = ({ content, tooltipContent = content }) => {
  return (
    <HtmlTooltip
      title={
        <React.Fragment>
          <Typography color="inherit" style={{ marginBottom: 0, fontWeight: 'bold', fontSize: '0.875rem' }}>
            {tooltipContent}
          </Typography>
        </React.Fragment>
      }
      interactive
      enterTouchDelay={0}
      arrow
      html="true"
    >
      <div>
        {content}
      </div>
    </HtmlTooltip>
  );
};


export const shouldOverride = (code,currentMoot) => {
    return !_.isNil(code) && code === currentMoot?.openOverrideCode
}




export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
      // storing input name
      localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};


export const calculateSimilarity = (str1, str2) => {
  if (!str1 || !str2) return 0;
  
  const s1 = str1.toLowerCase().trim();
  const s2 = str2.toLowerCase().trim();
  
  if (s1 === s2) return 1;
  
  // Levenshtein distance calculation
  const matrix = [];
  const len1 = s1.length;
  const len2 = s2.length;
  
  for (let i = 0; i <= len2; i++) {
    matrix[i] = [i];
  }
  
  for (let j = 0; j <= len1; j++) {
    matrix[0][j] = j;
  }
  
  for (let i = 1; i <= len2; i++) {
    for (let j = 1; j <= len1; j++) {
      if (s2.charAt(i - 1) === s1.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1, // substitution
          matrix[i][j - 1] + 1,     // insertion
          matrix[i - 1][j] + 1      // deletion
        );
      }
    }
  }
  
  const maxLen = Math.max(len1, len2);
  return maxLen === 0 ? 1 : (maxLen - matrix[len2][len1]) / maxLen;
};


export const normalizePhone = (phone) => {
  if (!phone) return '';
  // Remove all non-numeric characters
  return phone.replace(/\D/g, '');
};